import { Component } from 'react';
import { CardNumberEventHandler, CardNumberEventHandlerRegistrar } from '../createPciProxyService';

export interface PciProxyCardNumberProps {
    className?: string;
    id: string;
    onMetadataChange?: CardNumberEventHandler;
    onFocus?: CardNumberEventHandler;
    onBlur?: CardNumberEventHandler;
    registerChange: CardNumberEventHandlerRegistrar;
    registerFocus: CardNumberEventHandlerRegistrar;
    registerBlur: CardNumberEventHandlerRegistrar;
}

export default class PciProxyCardNumber extends Component<PciProxyCardNumberProps> {
    componentDidMount() {
        const { onMetadataChange, onBlur, onFocus } = this.props;

        if (onMetadataChange) {
            this.props.registerChange(onMetadataChange);
        }

        if (onFocus) {
            this.props.registerFocus(onFocus);
        }

        if (onBlur) {
            this.props.registerBlur(onBlur);
        }
    }

    render() {
        const { id, className } = this.props;
        const props = { id, className };

        return <div data-test-id="field-pci-proxy-card-number" {...props} />;
    }
}
